import axios from "../axios-auth";
import orginal_axios from "axios";

export const accountHeadService = {
    getAccountHeadList,
    saveAccountHead,
    getAccountHeadDetail,
    getAllAccountHead,
    getAccountHeadExcelExport,
    getAllAccountHeadList,
};

function getAllAccountHead() {
    return axios.get("/auth/all-account-head");
}

function getAccountHeadList(searchParams, page, size, sortedBy) {
    if (!page) {
        page = 0;
    } else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }

    let params = {
        page: page,
        size: size,
        sort: sortedBy
    };

    if (searchParams.name) {
        params["name"] = searchParams.name;
    }
    if (searchParams.status) {
        params["status"] = searchParams.status;
    }
    return axios.get("/auth/account-heads", { params });
}

function saveAccountHead(accountHead) {
    if (!accountHead.id) {
        // new brand
        return axios.post("/auth/account-head", accountHead);
    } else {
        // edit
        return axios.put("/auth/account-head", accountHead);
    }
}

function getAccountHeadDetail(id) {
    return axios.get("/auth/account-head/" + id);
}

function getAccountHeadExcelExport(searchParams) {
    let params = {};

    if (searchParams.name) {
        params["name"] = searchParams.name
    }

    if (searchParams.status) {
        params["status"] = searchParams.status;
    }

    return orginal_axios({
        method: "GET",
        url: axios.defaults.baseURL + "/auth/account-head-excel-export",
        params,
        responseType: "arraybuffer", // important
        headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
            Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        }
    }).then(function (response) {
        return { blob: new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), headers: response.headers }
    });
}

function getAllAccountHeadList(searchParams) {
    let params = {};

    if (searchParams.name) {
        params["name"] = searchParams.name;
    }

    if (searchParams.status) {
        params["status"] = searchParams.status;
    }

    return axios.get("/auth/print-account-heads", { params });
}